__turbopack_context__.v({
  "embla": "styles-module-scss-module__MdGuta__embla",
  "embla-container": "styles-module-scss-module__MdGuta__embla-container",
  "embla__container": "styles-module-scss-module__MdGuta__embla__container",
  "embla__slide": "styles-module-scss-module__MdGuta__embla__slide",
  "embla__slide__inner": "styles-module-scss-module__MdGuta__embla__slide__inner",
  "embla__viewport": "styles-module-scss-module__MdGuta__embla__viewport",
  "is-draggable": "styles-module-scss-module__MdGuta__is-draggable",
  "is-dragging": "styles-module-scss-module__MdGuta__is-dragging",
  "person-name": "styles-module-scss-module__MdGuta__person-name",
  "quote": "styles-module-scss-module__MdGuta__quote",
});
